import { Injectable, inject } from '@angular/core';
import { NgxsOnInit, Selector, State } from '@ngxs/store';

import { StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataEntityCollectionsRepository } from '@angular-ru/ngxs/repositories';
import { PartnerFirestoreService } from '../../services/partner.firestore.service';
import { PartnerStateModel } from './partner.store';
import { createEntityCollections } from '@angular-ru/cdk/entity';

@StateRepository()
@State<PartnerStateModel>({
  name: 'partners',
  defaults: {
    ...createEntityCollections<PartnerStateModel>(),
    partners: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class PartnerState extends NgxsDataEntityCollectionsRepository<PartnerStateModel> implements NgxsOnInit {
  private partnerService = inject(PartnerFirestoreService);

  override ngxsOnInit() {
    super.ngxsOnInit();
    this.partnerService.OnGetAll((partners) => this.patchState({ partners }));
  }

  @Selector()
  static partners(state: PartnerStateModel) {
    return state.partners;
  }
  @Selector()
  static partnersCount(state: PartnerStateModel) {
    return state.partners.length;
  }

  @Selector()
  static sums(state: PartnerStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: PartnerStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static partnerState(state: PartnerStateModel) {
    return state;
  }
}
